<template>
  <div class="hand-writing ">
    <template v-if="!view">
      <div class="relative">
        <canvas ref="container" class="rounded-small"></canvas>
        <template v-if="issue.url">
          <div class="absolute inset-0 z-10">
            <img :src="previewUrl" alt="" class="max-w-full"/>
          </div>
        </template>
      </div>
      <div class="mt-2" v-if="!view">
        <el-button class="w-full" @click="clear">清空</el-button>
      </div>
    </template>
    <template v-else>
      <template v-if="issue.url">
        <div>
          <img :src="previewUrl" alt="" class="max-w-full"/>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Signature from 'signature_pad'
import { convertUrl } from 'dygc'

export default {
  name: 'HandWriting',
  changeExpr: 'changeExpr',
  data() {
    return {
      changeExpr: false
    }
  },
  computed: {
    previewUrl() {
      if (this.issue.url) {
        return convertUrl(this.issue.url)
      } else {
        return ''
      }
    }
  },
  methods: {
    init() {
      if (this.view) return
      let el = this.$refs.container
      let signature = new Signature(el, {
        onEnd: () => {
          this.changeExpr = true
        }
      })
      // signature.addEventListener('endStroke', () => {
      //   this.changeExpr = true
      // })
      this.issue.setSignature(signature)
      this.$nextTick(() => {
        this.drawGrid('#ccc', 10, 10)
      })
    },
    drawGrid(color, stepx, stepy) {
      let canvas = this.$refs.container
      let context = canvas.getContext('2d')
      context.save()
      context.fillStyle = 'white'
      let cw = context.canvas.width
      let ch = context.canvas.height
      context.fillRect(0, 0, cw, ch)
      context.lineWidth = 0.5
      context.strokeStyle = color
      const fn = (x, y, lx, ly) => {
        context.beginPath()
        context.moveTo(x, y)
        context.lineTo(lx, ly)
        context.closePath()
        context.stroke()
      }
      for (let i = stepx; i < cw; i += stepx) {
        fn(i, 0, i, ch)
      }
      for (let j = stepy; j < ch; j += stepy) {
        fn(0, j, cw, j)
      }
      context.restore()
    },
    clear() {
      this.issue.url = ''
      this.issue.signature.clear()
      this.$nextTick(() => {
        this.drawGrid('#ccc', 10, 10)
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>
